export default __webpack_public_path__ + "assets/images/6d503ab2e695ee50897406a6f3f3c473-mgm-banner-start.svg";